import React from "react"
import { Link } from "gatsby"
import { FormattedMessage, useIntl } from "react-intl"
import classnames from "classnames"
import { useIsLangEN } from "../hooks"

const BreadCrumb = ({ pathArr = [], className }) => {
  const intl = useIntl()
  const isLangEN = useIsLangEN()
  // console.log("pathArr", pathArr)
  return (
    <div
      className={classnames(
        {
          "bread-crumb": true,
          "bread-crumb--en": isLangEN,
        },
        className
      )}
    >
      <ul>
        {pathArr.map(path => (
          <li key={path.langKey}>
            <Link
              to={`/${intl.locale}/${path.baseSlug ? path.baseSlug + "/" : ""}`}
              title={intl.formatMessage({ id: path.langKey })}
            >
              <FormattedMessage id={path.langKey}></FormattedMessage>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default BreadCrumb
